import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';
import emailjs from '@emailjs/browser';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-servicos-page',
  standalone: true,
  imports: [CommonModule, MenuComponent, RodapeComponent],
  templateUrl: './servicos.component.html',
  styleUrl: './servicos.component.css'
})
export class ServicosPageComponent implements OnInit, AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // Inicializar EmailJS
    if (isPlatformBrowser(this.platformId)) {
      emailjs.init({ publicKey: environment.emailjs.publicKey });
    }
  }

  ngOnInit(): void {
    // Inicialização do componente
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initializeForm();
    }
  }

  initializeForm(): void {
    // Aguardar o DOM estar pronto
    setTimeout(() => {
      this.setupMessageTypeToggle();
      this.setupFormSubmission();
    }, 100);
  }

  setupMessageTypeToggle(): void {
    const radios = document.querySelectorAll('input[name="tipoMensagem"]');
    const camposComerciais = document.getElementById('camposComerciais');
    const camposTecnicos = document.getElementById('camposTecnicos');

    radios.forEach(radio => {
      radio.addEventListener('change', (event: any) => {
        const tipo = event.target.value;

        if (tipo === 'comercial') {
          camposComerciais!.style.display = 'block';
          camposTecnicos!.style.display = 'none';
          
          // Limpar campos técnicos
          const produtoSelect = document.getElementById('produto') as HTMLSelectElement;
          const mensagemTecnica = document.getElementById('mensagemTecnica') as HTMLTextAreaElement;
          const urlTecnico = document.getElementById('urlTecnico') as HTMLTextAreaElement;
          
          if (produtoSelect) produtoSelect.value = '';
          if (mensagemTecnica) mensagemTecnica.value = '';
          if (urlTecnico) urlTecnico.value = '';
          
          // Remover required dos campos técnicos
          if (produtoSelect) produtoSelect.removeAttribute('required');
          if (mensagemTecnica) mensagemTecnica.removeAttribute('required');
          
          // Adicionar required nos campos comerciais
          const mensagemComercial = document.getElementById('mensagemComercial') as HTMLTextAreaElement;
          if (mensagemComercial) mensagemComercial.setAttribute('required', 'required');
          
        } else if (tipo === 'tecnica') {
          camposComerciais!.style.display = 'none';
          camposTecnicos!.style.display = 'block';
          
          // Limpar campos comerciais
          const mensagemComercial = document.getElementById('mensagemComercial') as HTMLTextAreaElement;
          const urlComercial = document.getElementById('urlComercial') as HTMLTextAreaElement;
          
          if (mensagemComercial) mensagemComercial.value = '';
          if (urlComercial) urlComercial.value = '';
          
          // Remover required dos campos comerciais
          if (mensagemComercial) mensagemComercial.removeAttribute('required');
          
          // Adicionar required nos campos técnicos
          const produtoSelect = document.getElementById('produto') as HTMLSelectElement;
          const mensagemTecnica = document.getElementById('mensagemTecnica') as HTMLTextAreaElement;
          if (produtoSelect) produtoSelect.setAttribute('required', 'required');
          if (mensagemTecnica) mensagemTecnica.setAttribute('required', 'required');
        }

        // Adicionar animação
        const visibleFields = tipo === 'comercial' ? camposComerciais : camposTecnicos;
        visibleFields!.style.animation = 'none';
        setTimeout(() => {
          visibleFields!.style.animation = 'fadeInUp 0.4s ease';
        }, 10);
      });
    });
  }



  setupFormSubmission(): void {
    const form = document.getElementById('contactForm') as HTMLFormElement;
    const submitBtn = form?.querySelector('.submit-btn') as HTMLButtonElement;
    const successMessage = document.getElementById('successMessage');
    const errorMessage = document.getElementById('errorMessage');

    if (form && submitBtn) {
      form.addEventListener('submit', async (event: Event) => {
        event.preventDefault();

        // Desabilitar botão e mostrar loading
        submitBtn.disabled = true;
        submitBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> <span>Enviando...</span>';

        try {
          // Validar formulário
          if (this.validateForm()) {
            const formData = await this.collectFormData();
            
            // Enviar via EmailJS
            const templateId = formData.tipoMensagem === 'comercial' 
              ? environment.emailjs.templateComercial 
              : environment.emailjs.templateTecnico;
            
            const response = await emailjs.send(
              environment.emailjs.serviceId,
              templateId,
              formData,
              { publicKey: environment.emailjs.publicKey }
            );

            console.log('Email enviado com sucesso:', response);

            // Mostrar mensagem de sucesso
            if (successMessage) {
              const p = successMessage.querySelector('p');
              if (p) p.innerHTML = '<i class="fa-solid fa-check-circle"></i> Mensagem enviada com sucesso! Entraremos em contato em breve.';
              successMessage.style.display = 'block';
              successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
            
            // Resetar formulário
            form.reset();
            
            // Resetar campos de URL
            const urlComercial = document.getElementById('urlComercial') as HTMLTextAreaElement;
            const urlTecnico = document.getElementById('urlTecnico') as HTMLTextAreaElement;
            if (urlComercial) urlComercial.value = '';
            if (urlTecnico) urlTecnico.value = '';
            
            // Voltar para campos comerciais
            const comercialRadio = document.querySelector('input[name="tipoMensagem"][value="comercial"]') as HTMLInputElement;
            if (comercialRadio) {
              comercialRadio.checked = true;
              comercialRadio.dispatchEvent(new Event('change'));
            }
            
            // Esconder mensagem de sucesso após 8 segundos
            setTimeout(() => {
              if (successMessage) successMessage.style.display = 'none';
            }, 8000);
          } else {
            // Mostrar mensagem de erro de validação
            this.showErrorMessage(errorMessage, 'Por favor, preencha todos os campos obrigatórios.');
          }
        } catch (error) {
          console.error('Erro ao enviar email:', error);
          // Mostrar mensagem de erro
          this.showErrorMessage(errorMessage, 'Ocorreu um erro ao enviar a mensagem. Por favor, tente novamente.');
        } finally {
          // Reabilitar botão
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<i class="fa-solid fa-paper-plane"></i> <span>Enviar Mensagem</span>';
        }
      });
    }

    // Configurar close buttons para alerts
    const closeButtons = document.querySelectorAll('[uk-close]');
    closeButtons.forEach(button => {
      button.addEventListener('click', () => {
        const alert = button.closest('.uk-alert') as HTMLElement;
        if (alert) {
          alert.style.display = 'none';
        }
      });
    });
  }

  validateForm(): boolean {
    const form = document.getElementById('contactForm') as HTMLFormElement;
    const nome = (document.getElementById('nome') as HTMLInputElement).value.trim();
    const email = (document.getElementById('email') as HTMLInputElement).value.trim();
    const telefone = (document.getElementById('telefone') as HTMLInputElement).value.trim();
    const tipoMensagem = (document.querySelector('input[name="tipoMensagem"]:checked') as HTMLInputElement)?.value;

    // Validações básicas
    if (!nome || !email || !telefone || !tipoMensagem) {
      return false;
    }

    // Validação de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return false;
    }

    // Validação específica por tipo
    if (tipoMensagem === 'comercial') {
      const mensagemComercial = (document.getElementById('mensagemComercial') as HTMLTextAreaElement).value.trim();
      return mensagemComercial !== '';
    } else if (tipoMensagem === 'tecnica') {
      const produto = (document.getElementById('produto') as HTMLSelectElement).value;
      const mensagemTecnica = (document.getElementById('mensagemTecnica') as HTMLTextAreaElement).value.trim();
      return produto !== '' && mensagemTecnica !== '';
    }

    return true;
  }

  collectFormData(): any {
    const nome = (document.getElementById('nome') as HTMLInputElement).value;
    const email = (document.getElementById('email') as HTMLInputElement).value;
    const telefone = (document.getElementById('telefone') as HTMLInputElement).value;
    const tipoMensagem = (document.querySelector('input[name="tipoMensagem"]:checked') as HTMLInputElement)?.value;
    
    const formData: any = {
      nome,
      email,
      telefone,
      tipoMensagem
    };
    
    if (tipoMensagem === 'comercial') {
      formData.mensagemComercial = (document.getElementById('mensagemComercial') as HTMLTextAreaElement).value;
      // Adicionar URLs de anexos comerciais
      formData.urlanexo = this.processURLs((document.getElementById('urlComercial') as HTMLTextAreaElement).value);
    } else {
      formData.produto = (document.getElementById('produto') as HTMLSelectElement).value;
      formData.mensagemTecnica = (document.getElementById('mensagemTecnica') as HTMLTextAreaElement).value;
      // Adicionar URLs de anexos técnicos
      formData.urlanexo = this.processURLs((document.getElementById('urlTecnico') as HTMLTextAreaElement).value);
    }
    
    return formData;
  }

  processURLs(urlsText: string): string {
    if (!urlsText.trim()) return 'Nenhuma URL';
    
    const urls = urlsText.split('\n')
      .map(url => url.trim())
      .filter(url => url.length > 0 && this.isValidURL(url));
    
    if (urls.length === 0) return 'Nenhuma URL válida';
    
    return urls.join('\n');
  }

  isValidURL(string: string): boolean {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  showErrorMessage(errorMessage: HTMLElement | null, message: string): void {
    if (errorMessage) {
      const p = errorMessage.querySelector('p');
      if (p) p.innerHTML = `<i class="fa-solid fa-exclamation-circle"></i> ${message}`;
      errorMessage.style.display = 'block';
      errorMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      
      // Esconder mensagem de erro após 5 segundos
      setTimeout(() => {
        if (errorMessage) errorMessage.style.display = 'none';
      }, 5000);
    }
  }
}
